import {
  CustomGeometryClassDefinition,
  CustomGeometryInstance,
} from './editor/custom';

export const IMAGES_ALLOWED_EXTENSIONS = ['jpg', 'png'] as const;
export const GEOMETRIES_ALLOWED_EXTENSIONS = ['stl'] as const;
export const METADATA_ALLOWED_EXTENSIONS = ['json'] as const;

export const ALLOWED_PROJECT_EXTENSIONS = [
  ...IMAGES_ALLOWED_EXTENSIONS,
  ...GEOMETRIES_ALLOWED_EXTENSIONS,
  ...METADATA_ALLOWED_EXTENSIONS,
] as const;

export type GeometryExtensions = (typeof GEOMETRIES_ALLOWED_EXTENSIONS)[number];
export type ImagesExtensions = (typeof IMAGES_ALLOWED_EXTENSIONS)[number];
export type MetadataExtensions = (typeof METADATA_ALLOWED_EXTENSIONS)[number];
export type ProjectFileExtensions = (typeof ALLOWED_PROJECT_EXTENSIONS)[number];

export type STLProjectFileCommon = {
  type: ProjectFileExtensions;
  baseName: string;
  fullName: string;
  ext: ProjectFileExtensions;
};

export type ObjectURLProjectFile = STLProjectFileCommon & {
  type: ImagesExtensions | GeometryExtensions;
  objectURL: string;
};

export type JSONProjectContent =
  | CustomGeometryInstance
  | CustomGeometryClassDefinition;

export type JSONProjectFile<T = JSONProjectContent> = STLProjectFileCommon & {
  type: Extract<ProjectFileExtensions, 'json'>;
  content: T;
};

export type ProjectFile = ObjectURLProjectFile | JSONProjectFile;
export type GeometryProjectFileWrapper<T = JSONProjectContent> = {
  [key in GeometryExtensions | ImagesExtensions]?: ObjectURLProjectFile;
} & { json: JSONProjectFile<T> };
